// client/legend-cms/src/predictionTeams/PredictionTeamEdit.js
import React from 'react';
import {
  Edit,
  SimpleForm,
  TextInput,
  SelectInput,
  BooleanInput,
  ImageInput,
  ImageField,
  DeleteButton,
  SaveButton,
  Toolbar,
  required,
} from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

const useStyles = makeStyles({
  inline: {
    display: 'inline-block',
    marginLeft: '1em',
    '&.first-child': {
      marginLeft: 0,
    },
  },
});

const typeChoices = [
  { id: 'national_team', name: 'Seleção nacional' },
  { id: 'club', name: 'Clube' },
];

// Igual ao PreviewImage de banners/BannerEdit.js e predictionCampaigns/
// PredictionCampaignEdit.js: o valor vindo do backend é uma string (URL
// assinada), mas o ImageField espera um record com a propriedade `source`
// — por isso embrulhamos a string antes de exibir.
const PreviewImage = ({ record, source }) => {
  if (typeof record === 'string') {
    record = { [source]: record };
  }
  return <ImageField record={record} source={source} />;
};

const TeamToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton />

    <DeleteButton
      mutationMode="pessimistic"
      confirmTitle="Excluir time"
      confirmContent="Tem certeza que deseja excluir este time? Só é possível excluir times sem partidas vinculadas."
    />
  </Toolbar>
);

const PredictionTeamEdit = (props) => {
  const classes = useStyles();

  return (
    <Edit title="Editar time" {...props}>
      <SimpleForm toolbar={<TeamToolbar />}>
        <TextInput
          source="name"
          label="Nome"
          helperText="Nome de exibição. Ex: Brasil, Flamengo."
          validate={required()}
          formClassName={clsx(classes.inline, 'first-child')}
        />

        <TextInput
          source="slug"
          label="Slug (identificador único)"
          helperText="Ex: brazil, flamengo. Não pode repetir."
          validate={required()}
          formClassName={classes.inline}
        />

        <div />

        <SelectInput
          source="type"
          label="Tipo"
          choices={typeChoices}
          validate={required()}
          formClassName={clsx(classes.inline, 'first-child')}
        />

        <BooleanInput
          source="active"
          label="Ativo"
          formClassName={classes.inline}
        />

        <div />

        <ImageInput
          source="image"
          label="Bandeira/Brasão"
          accept="image/jpeg,image/jpg,image/png,image/webp"
          helperText="jpg, png ou webp. Enviar uma nova substitui a atual; deixar como está preserva a imagem."
        >
          <PreviewImage source="src" />
        </ImageInput>
      </SimpleForm>
    </Edit>
  );
};

export default PredictionTeamEdit;
